<template>
  <StyledStatusBar>
    <div class="status-bar">
      <div class="status-bar__label">{{ $t(statusBar.label) }}</div>
      <div class="status-bar__step">{{ $t('step', { step: statusBar.step, steCnt: 4 }) }}</div>
    </div>
  </StyledStatusBar>
</template>

<script>
import { mapState } from 'vuex';
import styled from 'vue-styled-components';

const StyledStatusBar = styled.section`
  background-color: ${props => props.theme.primary};
  color: ${props => props.theme.on_primary};

  z-index: 105;
  position: relative;
  padding: 20px;

  .status-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export default {
  computed: {
    ...mapState(['statusBar']),
  },

  data() {
    return {
      expirationBlockText: {
        label: 'Lol',
      },
    };
  },

  components: {
    StyledStatusBar,
  },
};
</script>

<style></style>
